import React from 'react';
import Modal from 'react-modal';
import './login.css';
import successTick from './icons/successTick.png'
import successCancel from './icons/successCancel.png'

const customStyles = {
    overlay:{
      backgroundColor: 'transparent',
    },
  }

const SuccessPopup = ({ isOpen, onRequestClose, message }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    className='successpopbody'
    ariaHideApp={false}// This is added to prevent a11y warnings, adjust as needed
    style={customStyles}
  >
    <div className='successpopup'>
    <div style={{display:"flex",
         justifyContent:"space-between",
         alignItems:"center",
         color:"#FFFFFF"}}  ><img src={successTick} style={{height:"45px",
         width:"50px"}}></img>
      <p style={{fontSize:"20px"}}>{message}</p>
      <button onClick={onRequestClose} style={{border:"none",backgroundColor:"#6D9335"}}>
        <img src={successCancel}></img>
        </button>
    </div>
    </div>
  </Modal>
);

export default SuccessPopup;